import { enableProdMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { RequestInterceptor } from 'src/app/shared/config/requestInterceptor';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ToastrModule } from 'ngx-toastr';
import { AuthOidcApimModule } from '@cddng/auth-oidc-apim';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { RouterModule } from '@angular/router';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions} from '@angular/material/core';
import { FORMAT } from './app/shared/utils/dateFormat';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {AngularDesignSystemModule} from "@alf/angular-design-system";
import {FrenchDateProvider} from "./app/shared/utils/french-date-provider";
import {Messages} from "./app/shared/enums/messages.enum";
if (environment.production) {
  enableProdMode();
}

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true
};

registerLocaleData(localeFr, 'fr');

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, RouterModule.forRoot(
            AppRoutingModule,
            {
              scrollPositionRestoration: 'enabled'
            }
          ), ToastrModule.forRoot({
            maxOpened: 5,
            autoDismiss: true,
            positionClass: 'toast-top-right',
            timeOut: 3000,
            preventDuplicates: true
          }), AuthOidcApimModule.forRoot(environment.authentification),
          AngularDesignSystemModule.forRoot({
            theme: {
              default: 'transverse'
            },
            notifications: {
              verticalPosition: 'top'
            },
            paginator: {
              pageSize: 10,
              pageSizeOptions: [10,15,20,25,30],
              pageSizeMode: 'select',
              type: 'slice'
            },
            translation: {
              validation: {
                validCabS29 : Messages.ERROR_FORMAT_CAB_29,
                validCab: Messages.ERROR_FORMAT,
                pattern: Messages.ERROR_FORMAT
              }
            },
            validation: {
              maxErrorCount: 1,
            }
          })),
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: LOCALE_ID, useValue: 'fr' },
        { provide: MAT_DATE_FORMATS, useValue: FORMAT },
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig },
        { provide: DateAdapter, useClass: FrenchDateProvider }
    ]
}).catch(err => console.error(err));
